import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";
import { RevealLines, FadeUp, Overline } from "./Reveal";

const FAQS = [
  {
    q: "Lavori anche online o solo dal vivo?",
    a: "No, lavoro esclusivamente dal vivo. Credo fermamente che una reale trasformazione di valore richieda un approccio one to one, presenza, costanza e personalizzazione.",
  },
  {
    q: "In quali zone operi? È possibile richiedere una trasferta fuori dalla Lombardia?",
    a: "Opero stabilmente in tutta la Lombardia. Valuto con piacere trasferte dal vivo anche fuori regione per percorsi o consulenze dedicate: in questo caso, la fattibilità e i relativi costi di trasferta verranno calcolati e inseriti in un preventivo personalizzato.",
  },
  {
    q: "Non ho mai fatto consulenza d'immagine: da quale servizio devo iniziare?",
    a: "Dai servizi d'ingresso base: Armocromia e/o Body Shape. Se non sai da dove iniziare, seleziona l'opzione 'Non so da dove iniziare' nel modulo in alto: ti guiderò io nella scelta del primo passo più adatto alle tue esigenze.",
  },
  {
    q: "Come funzionano i percorsi e quali sono i requisiti d'accesso?",
    a: "Sono percorsi ad alto valore trasformativo distribuiti durante l'anno. Per accedere ai percorsi annuali è richiesta l'esecuzione preliminare di armocromia e bodyshape in modo da lavorare su basi solide e concrete.",
  },
  {
    q: "È possibile acquistare singoli servizi?",
    a: "Assolutamente sì. Oltre ai percorsi annuali, sono sempre disponibili i servizi singoli verticali, ideali se hai bisogno di un supporto immediato, stagionale o dedicato a un'occasione speciale.",
  },
  {
    q: "Cosa succede dopo che ho inviato il modulo di contatto?",
    a: "Leggerò personalmente le tue informazioni e ti ricontatterò su WhatsApp o via mail entro 24-48 ore per verificare la fattibilità logistica, conoscerti e fornirti tutti i dettagli.",
  },
];

export const Faq = () => {
  return (
    <section id="faq" className="relative py-24 sm:py-36 overflow-hidden" data-testid="faq-section">
      <div className="max-w-[1100px] mx-auto px-5 sm:px-8 relative z-10">
        <Overline className="mb-8">Domande Frequenti</Overline>
        <h2 className="font-display uppercase text-fuchsiabrand text-4xl sm:text-6xl lg:text-7xl leading-[1.02] tracking-tight max-w-3xl">
          <RevealLines lines={["Prima di", "scrivermi"]} />
        </h2>

        <FadeUp delay={0.15} className="mt-14">
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((item, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                className="border-b border-espresso/10"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="text-left font-sans font-bold text-lg sm:text-xl text-espresso hover:text-fuchsiabrand hover:no-underline py-6">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-stone text-base leading-relaxed pb-6 max-w-3xl">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </FadeUp>
      </div>
    </section>
  );
};
